import React, { useState, useEffect } from "react";
import logo from "../assets/webLogo.png";
import { styled } from "styled-components";
import Logout from "./Logout";
import altImage from "../assets/altImage.png";

const Contacts = ({ contacts, currentUser, changeChat, handleClose }) => {
  const [currentUserName, setCurrentUserName] = useState(undefined);
  const [currentUserImage, setCurrentUserImage] = useState(undefined);
  const [currentSelected, setCurrentSelected] = useState(undefined);

  useEffect(() => {
    if (currentUser) {
      setCurrentUserImage(currentUser.avatarImage);
      setCurrentUserName(currentUser.username);
    }
  }, [currentUser]);

  const changeCurrentChat = (index, contact) => {
    setCurrentSelected(index);
    changeChat(contact);
    if (handleClose) {
      handleClose();
    }
  };

  return (
    <>
      {currentUserImage && currentUserName && (
        <Container>
          <div className="brand">
            <img src={logo} alt="logo" />
            <h3>Chatify</h3>
          </div>
          <div className="contacts">
            {contacts.map((contact, index) => {
              return (
                <div
                  className={`contact ${
                    index === currentSelected ? "selected" : ""
                  }`}
                  key={index}
                  onClick={() => changeCurrentChat(index, contact)}
                >
                  <div className="avatar">
                    {contact.avatarImage === "" ? (
                      <img src={altImage} alt="avatar" />
                    ) : (
                      <img
                        src={`data:image/svg+xml;base64,${contact.avatarImage}`}
                        alt="avatar"
                      />
                    )}
                  </div>
                  <div className="username">
                    <h3>{contact.username}</h3>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="currentuser">
            <div className="avatar">


            {currentUserImage === "" ? (
                      <img src={altImage} alt="avatar" />
                    ) : (
                      <img
                        src={`data:image/svg+xml;base64,${currentUserImage}`}
                        alt="avatar"
                      />
              )}

            </div>
            <div className="username">
              <h3>{currentUserName}</h3>
            </div>
            <Logout />
          </div>
        </Container>
      )}
    </>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-rows: 10% 75% 15%;
  overflow: hidden;
  background-color: #080420;
  height: 100%;
  .brand {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    img {
      height: 2rem;
    }
    h3 {
      color: #fff;
      text-transform: uppercase;
    }
  }
  .contacts {
    display: flex;
    align-items: center;
    overflow: auto;
    flex-direction: column;
    gap: 0.8rem;
    &::-webkit-scrollbar {
      width: 0.2rem;
      &-thumb {
        background-color: #08f8ef;
      }
    }
    .contact {
      background-color: #ffffff39;
      min-height: 5rem;
      width: 90%;
      cursor: pointer;
      overflow: hidden;
      border-radius: 0.2rem;
      padding: 0.4rem;
      gap: 0.5rem;
      display: flex;
      align-items: center;
      transition: 0.4s ease-in-out;
      .avatar {
        img {
          height: 3rem;
        }
      }
      .username {
        h3 {
          font-size: 1.2rem;
          color: white;
        }
      }
    }
    .selected {
      background-color: #9186f3;
    }
  }

  .currentuser {
    background-color: #0d0d30;
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns:15% 50% 20%;
    gap: 0.4rem;
    .avatar {
      img {
        height: 3rem;
        max-inline-size: 100%;
      }
    }
    .username {
      display: flex;
      justify-content:flex-start;
      overflow: hidden;
      h3 {
        color: white;
        font-size: 1.2rem;
        text-transform: uppercase;
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .brand {
      gap: 1.5rem;
      img {
        height: 2rem;
      }
      h3 {
        font-size: 1.5rem;
      }
    }
    .contacts {
      display: flex;
      // justify-content: center;
      flex-direction: column;
      gap: 0.5rem;
      .contact {
        height: 1.5rem;
        width: 75%;
        border-radius: 0.2rem;
        padding: 0.2rem;
        gap: 0.8rem;
        .avatar {
          paddding: 0;
          img {
            height: 2.6rem;
          }
        }
        .username {
          paddding: 0;
          h3 {
            font-size: 1.4rem;
            font-weight: 400;
          }
        }
      }
    }

    .currentuser {
      gap: 1rem;
      .avatar {
        img {
          height: 3rem;
        }
      }
      .username {
        h3 {
          font-size: 1rem;
        }
      }
    }
  }
`;

export default Contacts;
